import gql from 'graphql-tag';
import {
  ProuniApplication,
  ProuniDocument,
  ProuniFamilyMember,
} from '@/store/modules/prouni/types';

export interface UpsertProuniApplicationResult {
  upsertProuniApplication: ProuniApplication;
}

export interface UpsertProuniFamilyMemberResult {
  upsertProuniFamilyMember: ProuniFamilyMember;
}

export interface RemoveProuniFamilyMemberResult {
  removeProuniFamilyMember: boolean;
}

export interface RemoveProuniDocumentResult {
  removeProuniDocument: boolean;
}

export interface SubmitProuniDocumentResult {
  submitProuniDocument: ProuniDocument;
}

export interface SubmitProuniApplicationResult {
  submitProuniApplication: ProuniApplication;
}

export interface ExchangeProuniEnrollmentTokenResult {
  exchangeProuniEnrollmentToken: {
    authToken: string;
  };
}

export const upsertProuniApplication = gql`
  mutation upsertProuniApplication($input: UpsertProuniApplicationInput!) {
    upsertProuniApplication(input: $input) {
      id
      status
    }
  }
`;

export const upsertProuniFamilyMember = gql`
  mutation upsertProuniFamilyMember($input: UpsertProuniFamilyMemberInput!) {
    upsertProuniFamilyMember(input: $input) {
      id
      name
      income
    }
  }
`;

export const removeProuniFamilyMember = gql`
  mutation removeProuniFamilyMember($id: Float!) {
    removeProuniFamilyMember(id: $id)
  }
`;

export const submitProuniDocument = gql`
  mutation submitProuniDocument(
    $documentType: ProuniDocumentType!
    $key: String!
    $fileName: String!
    $mimeType: String!
    $familyMemberId: Float
    $description: String
  ) {
    submitProuniDocument(
      documentType: $documentType
      key: $key
      fileName: $fileName
      mimeType: $mimeType
      familyMemberId: $familyMemberId
      description: $description
    ) {
      id
      documentType
      fileName
      mimeType
      status
      rejectionReason
      familyMemberId
      description
      url
    }
  }
`;

export const removeProuniDocument = gql`
  mutation removeProuniDocument($id: Float!) {
    removeProuniDocument(id: $id)
  }
`;

export const submitProuniApplication = gql`
  mutation submitProuniApplication {
    submitProuniApplication {
      id
      status
      ra
    }
  }
`;

/**
 * Troca a sessão Pocket (Bearer cookie `d`) pelo `admissions-auth-token` da
 * admissão provisionada na aprovação do ProUni. Autenticada pelo
 * `ProuniCandidateAuthGuard`: o backend exige inscrição `approved` e que o
 * cupom do link seja o do candidato logado — por isso o cupom na URL não é
 * credencial.
 */
export const exchangeProuniEnrollmentToken = gql`
  mutation exchangeProuniEnrollmentToken($voucher: String!) {
    exchangeProuniEnrollmentToken(voucher: $voucher) {
      authToken
    }
  }
`;
